/**
 * AI:
 * Status: "in progress"
 * Type: Page
 * SubType: WizardPage
 * Reason: POC wizard for creating CalculationLogicType via bulk mapping assistant
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {MenuItem} from 'primeng/api';
import {PageComponent} from '../../../../core/shared/mvs-page/page.component';
import {MvsCoreService} from '../../../../core/shared/service/mvs-core.service';
import {MvsObjectNavigationService} from '../../../../core/shared/navigation/mvs-object-navigation.service';
import {PageHeaderConfig} from '../../../../core/shared/service/page/page-header-config.interface';
import {
    MvsConfigHeaderComponent
} from '../../../../core/shared/components/mvs-config-header/mvs-config-header.component';
import {LgPocWizardStateService} from '../../service/domain/lg-poc-wizard-state/lg-poc-wizard-state.service';
import {LgPocWizardStepStatusEnum} from '../../enum/lg-poc-wizard-step-status.enum';

@Component({
    selector: 'lg-poc-calculation-mapping-assistant-page',
    templateUrl: './lg-poc-calculation-mapping-assistant-page.page.html',
    styleUrls: ['./lg-poc-calculation-mapping-assistant-page.page.scss'],
    standalone: false,
    providers: [LgPocWizardStateService]
})
export class LgPocCalculationMappingAssistantPagePage extends PageComponent implements OnInit, OnDestroy {

    stepItems: MenuItem[] = [];
    activeStep: number = 0;

    private destroy$ = new Subject<void>();

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService,
        protected navigationService: MvsObjectNavigationService,
        protected wizardState: LgPocWizardStateService,
        protected router: Router
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        this.defaultLabel = 'Berechnungslogiktyp erstellen';
        super.ngOnInit();

        this.wizardState.initializeWizard();

        this.wizardState.state$.pipe(takeUntil(this.destroy$)).subscribe(state => {
            this.updateActiveStep();
        });

        this.initialized = true;
    }

    private updateActiveStep(): void {
        const state = this.wizardState.state;
        if (state.step1.status === LgPocWizardStepStatusEnum.IN_PROGRESS ||
            state.step1.status === LgPocWizardStepStatusEnum.FAILED) {
            this.activeStep = 0;
        } else if (state.step2.status === LgPocWizardStepStatusEnum.IN_PROGRESS ||
            state.step2.status === LgPocWizardStepStatusEnum.FAILED) {
            this.activeStep = 1;
        } else if (state.step3.status === LgPocWizardStepStatusEnum.IN_PROGRESS ||
            state.step3.status === LgPocWizardStepStatusEnum.COMPLETED) {
            this.activeStep = 2;
        }
        this.buildStepItems();
    }

    private buildStepItems(): void {
        this.stepItems = [
            {label: 'Grundlagen'},
            {label: 'Logik-Blöcke'},
            {label: 'Fertig'}
        ];
    }

    onGoBack(stepNumber: number): void {
        if (stepNumber === 2) {
            this.wizardState.goBackToStep2();
        } else {
            this.wizardState.goBackToStep1();
        }
    }

    onFinish(): void {
        const state = this.wizardState.state;
        if (state.createdTypeId) {
            this.navigationService.handlePageNavigation(
                `/lg/calculation-logic/${state.createdTypeId}`,
                null,
                {openNewTab: false}
            );
        }
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Berechnungslogiktyp erstellen',
                categoryTypeMode: 'technical',
                icon: 'fa-regular fa-wand-magic-sparkles'
            }
        };
    }

    canDeactivate(): boolean {
        const state = this.wizardState.state;
        if (state.step2.status === LgPocWizardStepStatusEnum.COMPLETED) return true;
        if (!state.createdTypeId) return true;
        return confirm(
            'Der Berechnungslogiktyp wurde bereits angelegt, aber der Assistent ist noch nicht abgeschlossen.\n\n' +
            'Möchten Sie die Seite wirklich verlassen?'
        );
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.destroy$.next();
        this.destroy$.complete();
    }
}
